import * as tslib_1 from "tslib";
import { MatDialog } from '@angular/material';
import { Effect, Actions, ofType } from '@ngrx/effects';
import { tap } from 'rxjs/operators';
import { ErrorDialogComponent } from '@awp/common';
import * as actions from './actions';
var ErrorEffects = /** @class */ (function () {
    function ErrorEffects(actions$, dialog) {
        var _this = this;
        this.actions$ = actions$;
        this.dialog = dialog;
        this.errors$ = this.actions$.pipe(ofType(actions.ActionTypes.BIN_SEARCH_FAILURE, actions.ActionTypes.SELECT_CARD_TYPE_FAILURE), tap(function (action) {
            var error = action.error;
            _this.dialog.open(ErrorDialogComponent, {
                data: { error: error }
            });
        }));
    }
    tslib_1.__decorate([
        Effect({ dispatch: false }),
        tslib_1.__metadata("design:type", Object)
    ], ErrorEffects.prototype, "errors$", void 0);
    return ErrorEffects;
}());
export { ErrorEffects };
